
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import DefaultLayout from '@/components/DefaultLayout.vue';
import AdminServices from '@/services/admin-service';
const namespace: string = 'profile';
@Component({
  components: { DefaultLayout }
})
export default class AdminDashboard extends Vue {
  /* Properties */
  /* Store Actions */
  @Action('logout', { namespace }) logout: any;
  /* Watchers */
  /* Data */
  adminActions: any = [
    // {
    //   title: 'Manage Users',
    //   subtitle: 'Modify individual user accounts',
    //   pathName: ''
    // },
    {
      title: 'Manage Customers',
      subtitle: 'Act on behalf of a Customer or modify their options',
      pathName: 'ManageCustomer'
    },
    {
      title: 'Static Data Import',
      subtitle: 'Import items in bulk for transparency customers',
      pathName: 'DataImportation'
    },
    {
      title: 'Refresh Caches',
      subtitle: 'Flush current caches and regrab them from the database',
      pathName: 'ManageCache'
    },
    {
      title: 'Order by File',
      subtitle: 'Renamed from ANS Order Processor',
      pathName: 'OrderByFile'
    }
  ];
  adminMiscOptions: any = [
    {
      title: 'Code Manager',
      subtitle: 'Check the status of Amazon request codes',
      pathName: 'CodeManager'
    },
    {
      title: 'Send Weekly Report to Amazon',
      subtitle: 'Use the previous Sunday for Date.',
      pathName: 'AmazonTransReport'
    },
    {
      title: 'Export Customer Items',
      subtitle: 'Export customer items for an order',
      pathName: 'ItemOrderExport'
    },
    {
      title: 'Activity Log',
      subtitle: 'Who done what',
      pathName: 'Activity Log'
    },
    { title: 'Go to main site', subtitle: '', pathName: 'mainsite' },
    {
      title: 'Json to CSV',
      subtitle: 'Convert raw Json text to csv format',
      pathName: 'JsonToCsv'
    }
  ];
  /* Methods */
  async goTo(pathName: string, title: string) {
    if (pathName == 'mainsite') {
      window.location.href = `${process.env.VUE_APP_J1L_URL}/redirectFromTransparency`;
    }
    this.$router.push({ name: pathName });
  }
  /* Loaders */
  /* Mounted */
  /* Created */
}
